import { jsx, jsxs } from "react/jsx-runtime";
import { IconHamburger, IconShareChatHeader, IconClose } from "./ConciergeIcons.js";
import { ConciergeHomeMobileNavWidget, ConciergeHomeLogoWidget } from "@brandclub/bc-widgets";
const ConciergeHomeMobileNav = ({
  brandLogoUrl,
  onMenuClick,
  onCloseClick,
  onShareClick
}) => {
  return /* @__PURE__ */ jsx(ConciergeHomeMobileNavWidget, { children: (state, icons, resolveColor) => {
    const bgColor = resolveColor(state.navBgColor);
    const hamburgerColor = resolveColor(state.hamburgerIconColor);
    const closeColor = resolveColor(state.closeIconColor);
    const ACTION_GAP = 12;
    const rightGroupWidth = onShareClick ? state.closeIconSize * 2 + ACTION_GAP : state.closeIconSize;
    return /* @__PURE__ */ jsxs(
      "nav",
      {
        "data-concierge-mobile-nav": true,
        style: {
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          height: state.navHeight,
          padding: `${state.navPaddingY}px ${state.navPaddingX}px`,
          boxSizing: "border-box",
          flexShrink: 0,
          color: hamburgerColor || void 0,
          ...bgColor && bgColor !== "transparent" ? { backgroundColor: bgColor } : {}
        },
        children: [
          /* @__PURE__ */ jsx(
            "div",
            {
              style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                width: rightGroupWidth,
                flexShrink: 0
              },
              children: /* @__PURE__ */ jsx(
                "button",
                {
                  type: "button",
                  onClick: onMenuClick,
                  "aria-label": "Open menu",
                  style: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: state.hamburgerIconSize,
                    height: state.hamburgerIconSize,
                    padding: 0,
                    border: "none",
                    background: "none",
                    cursor: "pointer"
                  },
                  children: icons.hamburgerIconUrl ? /* @__PURE__ */ jsx(
                    "img",
                    {
                      src: icons.hamburgerIconUrl,
                      alt: "Menu",
                      style: {
                        width: state.hamburgerIconSize,
                        height: state.hamburgerIconSize,
                        objectFit: "contain"
                      }
                    }
                  ) : /* @__PURE__ */ jsx(IconHamburger, { size: state.hamburgerIconSize, style: { color: hamburgerColor } })
                }
              )
            }
          ),
          state.showLogo ? /* @__PURE__ */ jsx(
            "div",
            {
              style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flex: 1,
                minWidth: 0,
                padding: "0 8px"
              },
              children: /* @__PURE__ */ jsx("div", { style: { width: "100%", maxWidth: 120 }, children: /* @__PURE__ */ jsx(
                ConciergeHomeLogoWidget,
                {
                  widgetId: "concierge-home-mobile-nav-logo",
                  displayName: "Mobile Nav Logo",
                  initialState: {
                    logoWidth: 79,
                    mobile_logoWidth: 79,
                    logoMaxHeight: 18
                  },
                  logoUrl: brandLogoUrl
                }
              ) })
            }
          ) : /* @__PURE__ */ jsx("div", { style: { width: state.closeIconSize, height: state.closeIconSize } }),
          /* @__PURE__ */ jsxs(
            "div",
            {
              style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                gap: ACTION_GAP,
                width: rightGroupWidth,
                flexShrink: 0
              },
              children: [
                onShareClick && /* @__PURE__ */ jsx(
                  "button",
                  {
                    type: "button",
                    onClick: onShareClick,
                    "aria-label": "Share conversation",
                    style: {
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: state.closeIconSize,
                      height: state.closeIconSize,
                      padding: 0,
                      border: "none",
                      background: "none",
                      cursor: "pointer"
                    },
                    children: /* @__PURE__ */ jsx(IconShareChatHeader, { size: 24, style: { color: closeColor } })
                  }
                ),
                /* @__PURE__ */ jsx(
                  "button",
                  {
                    type: "button",
                    onClick: onCloseClick,
                    "aria-label": "Close",
                    style: {
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: state.closeIconSize,
                      height: state.closeIconSize,
                      padding: 0,
                      border: "none",
                      background: "none",
                      cursor: "pointer"
                    },
                    children: icons.closeIconUrl ? /* @__PURE__ */ jsx(
                      "img",
                      {
                        src: icons.closeIconUrl,
                        alt: "Close",
                        style: {
                          width: state.closeIconSize,
                          height: state.closeIconSize,
                          objectFit: "contain"
                        }
                      }
                    ) : /* @__PURE__ */ jsx(IconClose, { size: state.closeIconSize, style: { color: closeColor } })
                  }
                )
              ]
            }
          )
        ]
      }
    );
  } });
};
export {
  ConciergeHomeMobileNav
};
//# sourceMappingURL=ConciergeHomeMobileNav.js.map
